module.exports = __webpack_public_path__ + "img/ofdyl.85aa54d6.svg";